export function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    const expiresString = expires.toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expiresString};path=/`;
  }
  